import { Box, Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import PasswordInput from "../../components/ui/PasswordInput";
import Text from "../../components/ui/Text";
import { useAuth } from "../../contexts/AuthContext";

const SettingsEmail = ({ isDesktop = false }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState("");

  const handleBack = () => {
    navigate("/settings");
  };

  const handleSave = () => {
    // TODO: Implement save logic
    navigate("/settings");
  };

  const isSaveDisabled = !email || !password;
  useEffect(() => {
    setEmail(currentUser.email);
  }, [currentUser.email]);

  // Desktop layout (no container, no back button)
  if (isDesktop) {
    return (
      <Box>
        {/* Form Fields */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            mb: "40px",
          }}
        >
          <Input
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
          />

          <PasswordInput
            label="Confirm password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>

        {/* Save Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isSaveDisabled || true}
            sx={{ minWidth: "120px", width: "auto" }}
          >
            Save
          </Button>
        </Box>
      </Box>
    );
  }

  // Mobile layout (original)
  return (
    <Container maxWidth="sm" sx={{ mt: 2 }}>
      {/* Back Button */}
      <Box sx={{ mb: "24px" }}>
        <Button variant="back" onClick={handleBack} />
      </Box>

      {/* Page Header */}
      <Text variant="pageHeader" sx={{ mb: "40px" }}>
        Email
      </Text>

      {/* Form Fields */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          mb: "40px",
        }}
      >
        <Input
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
        />

        <PasswordInput
          label="Confirm password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Box>

      {/* Save Button */}
      <Button
        variant="primary"
        onClick={handleSave}
        disabled={isSaveDisabled || true}
        sx={{ width: "100%" }}
      >
        Save
      </Button>
    </Container>
  );
};

export default SettingsEmail;
